import React, { useEffect, useState } from "react";
import { getAllUsersCombined } from "../../services/userServices/combinedUserService";

const KodeKaryawanInput = ({ register, errors, setValue }) => {
  const [usedCodes, setUsedCodes] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [lastUsed, setLastUsed] = useState("-");
  const [formattedValue, setFormattedValue] = useState("");

  useEffect(() => {
    const fetchUsedCodes = async () => {
      try {
        const users = await getAllUsersCombined();
        const semuaEmployeeID = users
          .filter((u) => u.is_active && u.employees?.employee_id)
          .map((u) => {
            const num = u.employees.employee_id
              .replace("STN-", "")
              .padStart(6, "0");
            return `STN-${num}`;
          });
        setUsedCodes(semuaEmployeeID);

        const lastNumber = semuaEmployeeID
          .map((id) => parseInt(id.replace("STN-", ""), 10))
          .sort((a, b) => b - a)[0];

        const lastUsedCode = lastNumber
          ? `STN-${String(lastNumber).padStart(6, "0")}`
          : "-";
        setLastUsed(lastUsedCode);
      } catch (err) {
        console.error("Gagal ambil employee_id:", err);
      }
    };

    fetchUsedCodes();
  }, []);

  useEffect(() => {
    const padded = inputValue ? inputValue.padStart(6, "0") : "";
    const fullCode = padded ? `STN-${padded}` : "";

    setFormattedValue(fullCode);
    setValue("employee_id", fullCode);

    if (fullCode && usedCodes.includes(fullCode)) {
      setErrorMsg("Kode sudah digunakan");
    } else {
      setErrorMsg("");
    }
  }, [inputValue, usedCodes, setValue]);

  const handleChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    setInputValue(raw);
  };

  return (
    <div>
      <label className="block mb-1 text-sm font-semibold text-green-800">
        Kode Karyawan <span className="text-red-500">*</span>
      </label>
      <input
        type="text"
        placeholder={
          lastUsed && lastUsed !== "-"
            ? `kode selanjutnya ${
                parseInt(lastUsed.replace("STN-", ""), 10) + 1
              } → akan jadi STN-${String(
                parseInt(lastUsed.replace("STN-", ""), 10) + 1
              ).padStart(6, "0")}`
            : "Masukkan kode → akan jadi STN-000001"
        }
        value={inputValue}
        onChange={handleChange}
        className={`w-full px-3 py-2 text-sm border rounded-md focus:ring-2 ${
          errorMsg
            ? "border-red-500 focus:ring-red-300"
            : "border-green-300 focus:ring-green-400"
        }`}
      />

      {formattedValue && (
        <small className="block mt-1 text-sm text-gray-500">
          Akan dikirim sebagai:{" "}
          <span className="font-mono">{formattedValue}</span>
        </small>
      )}
      {lastUsed && (
        <small className="block text-sm text-gray-400">
          Kode terakhir: <span className="font-mono">{lastUsed}</span>
        </small>
      )}
      {errorMsg && <p className="mt-1 text-sm text-red-500">{errorMsg}</p>}
      {errors?.employee_id && (
        <p className="mt-1 text-sm text-red-500">
          {errors.employee_id.message}
        </p>
      )}
    </div>
  );
};

export default KodeKaryawanInput;
